import { render, staticRenderFns } from "./view.html?vue&type=template&id=0108a69f&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=0108a69f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108a69f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0108a69f')) {
      api.createRecord('0108a69f', component.options)
    } else {
      api.reload('0108a69f', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=0108a69f&scoped=true&", function () {
      api.rerender('0108a69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/custom_button/index.vue"
export default component.exports